import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ListItem } from './ListItem';
import { ListItemText } from './ListItemText';
import { withTheme, WithTheme } from '@material-ui/core/styles';

const LoadingItemComponent: React.FC<WithTheme> = ({ theme }) => (
  <ListItem>
    <ListItemText style={{ textAlign: 'center' }}>
      <CircularProgress size={theme.spacing(4)} />
    </ListItemText>
  </ListItem>
);

export const LoadingItem = withTheme(LoadingItemComponent);
